<template>
  <app-panel title="История отправки" class="employee-debtors-history-send-email-panel" flex>
    <template v-if="SEND_TYPES.house === sendType">
      <template v-if="buildingsId">
        <div class="employee-debtors-history-send-email-panel__table-wrapper">
          <grid-infinite-scroll ref="buildingTable"
                                key="buildingTable"
                                :columns="columnsBuilding"
                                :getData="getBuildingHistory"
                                :maxConcurrentDatasourceRequests="4"
                                :pageSize="20"
                                :filterable="false"
                                :sortable="false"
                                noRowsText="История пуста"/>
        </div>
      </template>

      <div v-else class="employee-debtors-history-send-email-panel__no-building">
        Для просмотра истории выберите дом
      </div>
    </template>

    <template v-if="SEND_TYPES.email === sendType">
      <div class="employee-debtors-history-send-email-panel__table-wrapper">
        <grid-infinite-scroll ref="emailTable"
                              key="emailTable"
                              :columns="columnsEmail"
                              :getData="getEmailData"
                              :maxConcurrentDatasourceRequests="4"
                              :pageSize="20"
                              :filterable="false"
                              :sortable="false"
                              noRowsText="История пуста"/>
      </div>

    </template>
  </app-panel>
</template>

<script>

  const SEND_TYPES = {
    house: 0,
    email: 1
  };

  export default {
    name: "HistoryPanel",
    props: {
      sendType: {},
      buildingsId: {}
    },
    data(){
      return {
        SEND_TYPES: SEND_TYPES,
        emailHistory: [],
        buildingHistory: [],
        columnsBuilding: [
          {
            headerName: 'Дата отправки',
            field: 'created_at',
            minWidth: 180,
            pinned: 'left',
            valueGetter: ({data}) => {
              return this.$options.filters.moment(data.created_at, 'DD.MM.YYYY HH:mm:ss');
            },
          },
          {
            headerName: 'Список Л/С',
            field: 'list',
            minWidth: 180,
            valueGetter: ({data}) => {
              return data.list === null ? 'Все' : data.list;
            },
          },
          {
            headerName: 'Тема письма',
            field: 'name',
            minWidth: 180,
          },
          {
            headerName: 'Отправитель',
            field: 'user',
            minWidth: 180,
            suppressSizeToFit: false,
            valueGetter: ({data}) => {
              return data.user ? data.user.name : "Неизвестно";
            },
          },
        ],
        columnsEmail: [
          {
            headerName: 'Дата отправки',
            field: 'created_at',
            minWidth: 180,
            pinned: 'left',
            valueGetter: ({data}) => {
              return this.$options.filters.moment(data.created_at, 'DD.MM.YYYY HH:mm:ss');
            },
          },
          {
            headerName: 'Email',
            field: 'email',
            minWidth: 180,
          },
          {
            headerName: 'Тема письма',
            field: 'name',
            minWidth: 180,
          },
          {
            headerName: 'Отправитель',
            field: 'user',
            minWidth: 180,
            suppressSizeToFit: false,
            valueGetter: ({data}) => {
              return data.user ? data.user.name : "Неизвестно";
            },
          },
        ],
      }
    },
    methods: {
      getBuildingHistory(page, filters, orderBy){
        return new Promise(async (resolve) => {
          let {data} = await this.$http.get('custom_mails', {
            params: {
              page: page,
              orderby: orderBy,
              filters: filters,
              buildings_id: this.buildingsId,
            }
          });
          resolve({
            response: data,
            total: data.total,
            data: data.data
          })
        });
      },
      getEmailData(page, filters, orderBy){
        return new Promise(async (resolve) => {
          let {data} = await this.$http.get('send_one_mail_list', {
            params: {
              page: page,
              orderby: orderBy,
              filters: filters,
            }
          });
          resolve({
            response: data,
            total: data.total,
            data: data.data
          })
        });
      }
    },
    watch: {
      buildingsId(){
        if(this.buildingsId && this.$refs.buildingTable){
          this.$refs.buildingTable.resetData();
        }
      }
    }
  }
</script>

<style lang="scss">
  .employee-debtors-history-send-email-panel{
    height: 80vh;
    min-height: 500px;

    &__no-building{
      text-align: center;
      font-weight: 500;
      line-height: 1.1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__table-wrapper{
      display: flex;
      flex-direction: column;
      height: 100%;
    }

  }
</style>
